export default __webpack_public_path__ + "static/media/companies_gray_2.07e43374.png";